export const agConsultasProps = {
  basename: "/plataforma/consultas/agendamento",
};
